document.addEventListener('DOMContentLoaded', function () {
  const loadMoreBtn = document.getElementById('LoadMore');

  if (loadMoreBtn) {
    loadMoreBtn.addEventListener('click', function () {
      const nextUrl = loadMoreBtn.dataset.nextUrl;

      fetch(nextUrl)
        .then(response => response.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newItems = doc.querySelectorAll('.commonItemList > li');
          const itemList = document.querySelector('.commonItemList');

          newItems.forEach(item => itemList.appendChild(item));

          // 次のページがあるか再確認
          const newNextButton = doc.querySelector('#LoadMore');
          if (newNextButton) {
            loadMoreBtn.dataset.nextUrl = newNextButton.dataset.nextUrl;
          } else {
            loadMoreBtn.remove(); // 次がなければボタンを消す
          }
        })
        .catch(error => {
          console.error('Error loading more products:', error);
        });
    });
  }
});